import React, { useState, useRef, useMemo, useCallback } from 'react';

import { format } from 'date-fns';

import { Report } from '~/components';
import { Shifts } from '~/componentslocal';
import { Input, RadioGroup } from '~/components/Form';

export default function DlgAbastecA2VFComp() {
  const formRef = useRef(null);

  const [open, setOpen] = useState(true);
  const [toolbar, setToolbar] = useState({});

  const initialData = useMemo(
    () => ({
      datahorainicial: format(new Date(), 'dd/MM/yyyy 00:00:00'),
      datahorafinal: format(new Date(), 'dd/MM/yyyy 23:59:59'),
      tipo: 'pdf',
    }),
    []
  );

  const optionsType = useMemo(
    () => [
      { label: 'PDF', value: 'pdf' },
      { label: 'Excel', value: 'xls' },
    ],
    []
  );

  const handleCloseReport = useCallback(() => {
    setOpen(false);
  }, []);

  const handleSerializeData = useCallback(
    (data) => {
      const { tank, station, initial, final } = toolbar;
      const { tim_veiculo, tipo } = data;

      const formData = {
        post_cod_posto: tank,
        posto_str: station,
        turn_datahora_ini: initial,
        turn_datahora_fim: final,
        tim_veiculo,
        tipo,
      };

      return formData;
    },
    [toolbar]
  );

  return (
    <Report
      ref={formRef}
      open={open}
      initials={initialData}
      title="Relatório Comparativo Abastecimentos A2VF"
      relatorio="REL_COMPARATIVO_ABASTECIMENTOS_A2VF"
      onClose={handleCloseReport}
      serialize={handleSerializeData}
    >
      <Shifts forms={formRef} onToolbar={(value) => setToolbar(value)} />

      <Input name="tim_veiculo" label="Veículo" />

      <RadioGroup
        row
        name="tipo"
        label="Formato de Saída"
        options={optionsType}
      />
    </Report>
  );
}
